{
  "errorBoundary": {
    "dashboard": "工具箱仪表盘加载失败。",
    "extractor": "模型提取器视图加载失败。",
    "extractorRun": "模型提取器运行视图加载失败。",
    "gatekeeper": "提交审核器视图加载失败。",
    "gatekeeperRun": "提交审核器运行视图加载失败。",
    "logicInspector": "缺陷猎手视图加载失败。",
    "logicInspectorRun": "缺陷猎手运行视图加载失败。",
    "docReviewer": "文档审阅器视图加载失败。",
    "docReviewerRun": "文档审阅器运行视图加载失败。",
    "codeWalkthrough": "代码逐行审阅加载失败。",
    "codeWalkthroughRun": "该次运行加载失败。"
  },
  "dashboard": {
    "title": "可用工具",
    "empty": "暂无可用工具。",
    "loading": "加载中…",
    "loadFailedFallback": "加载任务失败",
    "activeRuns": "进行中任务",
    "activeIdle": "空闲",
    "activeRunningSuffix": "运行中 · 每 4 秒刷新",
    "tools": "工具",
    "toolsAvailableLabel": "可用",
    "extractorTileName": "模型提取器 (Extractor)",
    "extractorTileCap": "将 Excel 工作簿中嵌入的复杂模型逻辑提取为一个资产包 —— 便于人工评审和 AI 智能体使用。",
    "gatekeeperTileName": "提交守门员 (Gatekeeper)",
    "gatekeeperTileCap": "对提交包进行快速接收检查。导入文件（或整个文件夹），配上清单，在深度校验开始之前就能得到通过/未通过的结论以及缺失项清单。",
    "lastUsed": "上次使用",
    "open": "打开",
    "flawHunterTileName": "缺陷扫描 (Flaw Hunter)",
    "flawHunterTileCap": "对模型代码进行静态扫描，检出数据使用与逻辑反模式 —— 支持 Python / R / SAS / SQL / JS / TS / Java / Go / Rust 等语言。Excel 模型请改用「模型提取器」。",
    "docInspectorTileName": "文档审查 (Doc Inspector)",
    "docInspectorTileCap": "针对第三方模型文档（DOCX / PDF / MD）进行单文档一致性与监管合规检查。",
    "recentOutputs": "近期输出",
    "recentMetaSuffix": "全部运行 · 分页展示",
    "noCompleted": "暂无已完成的任务。将工作簿拖入提取器即可开始。",
    "nothingRunning": "当前没有任务在运行。",
    "table": {
      "tool": "工具",
      "target": "目标",
      "finished": "完成时间",
      "duration": "耗时",
      "output": "输出",
      "openArrow": "打开 →"
    },
    "phaseLabel": "阶段",
    "started": "开始于 {{time}}",
    "elapsed": "已用时 · {{value}}",
    "queued": "排队中",
    "running": "运行中",
    "codeWalkthroughTileName": "代码逐行审阅",
    "codeWalkthroughTileCap": "由模型代码生成按行锚定的审阅工作簿"
  },
  "pagination": {
    "showing": "显示 <0>{{from}}–{{to}}</0> 共 <1>{{total}}</1> 条",
    "prev": "‹ 上一页",
    "next": "下一页 ›",
    "loading": "加载中…",
    "loadFailed": "加载任务失败"
  },
  "extractor": {
    "title": "提取器 (Extractor)",
    "subtitle": "从电子表格和文档中提取结构化数据。",
    "uploadButton": "上传文件",
    "selectFile": "请选择文件以开始。",
    "supportedFormats": "支持 XLSX、CSV、PDF、DOCX。",
    "running": "提取器运行中…",
    "complete": "提取完成。",
    "failed": "提取失败。",
    "downloadResult": "下载结果",
    "viewResult": "查看结果",
    "rerun": "重新运行",
    "presetLabel": "2. 选择预设",
    "pickWorkbookLabel": "1. 选择工作簿",
    "noPreset": "无预设",
    "outputFormat": "输出格式",
    "runHistory": "近期运行",
    "noHistory": "无近期运行。",
    "openRun": "打开运行",
    "headline": "模型提取器 (Extractor)",
    "headlineDescription": "将 Excel 工作簿中嵌入的复杂模型逻辑 —— 公式、VBA、透视表、命名区域、依赖关系图 —— 提取为一个独立的资产包，便于人工评审和 AI 智能体使用。",
    "toolbox": "工具箱",
    "runExtraction": "运行提取",
    "fileBadge": ".xlsx · .xlsm",
    "presetCustom": "自定义（手动覆盖）",
    "presetActive": "{{name}}",
    "presetButtons": {
      "highLevel": "概览级",
      "highLevelCap": "便于速览 · 启用模式识别",
      "balanced": "均衡级",
      "balancedCap": "合理默认 · 轻量后处理",
      "detailed": "详细级",
      "detailedCap": "覆盖深入 · 完整枚举"
    },
    "extractionDepth": "3. 配置提取深度",
    "extractionDepthHint": "原始层始终无损",
    "rows": {
      "vba": "VBA 模块",
      "vbaHelp": "按模块逐字保留源码。标准级会增加过程索引。深度级会增加 Range/Cells/Sheets 的交互提取。",
      "pivots": "数据透视表",
      "pivotsHelp": "标准级保留配置。深度级会按输出单元格合成衍生计算。",
      "powerQuery": "Power Query (M)",
      "powerQueryHelp": "按查询逐字保留 M 源码。深度级会增加步骤链解析。",
      "namedRanges": "命名区域",
      "namedRangesHelp": "轻量级 = 名称 + 原始引用。标准级会增加解析后的单元格列表。深度级会按单元格记录归属。",
      "conditionalFormatting": "条件格式",
      "conditionalFormattingHelp": "标准级保留规则。深度级会按单元格记录归属。",
      "dataValidation": "数据验证",
      "dataValidationHelp": "标准级保留规则。标准级已包含按单元格归属记录。",
      "charts": "图表",
      "chartsHelp": "轻量级保留清单。标准级会增加数据系列的源绑定。",
      "externalLinks": "外部链接",
      "externalLinksHelp": "轻量级保留清单。标准级会增加按单元格的消费方记录。"
    },
    "postProcessing": "4. 配置后处理",
    "postProcessingHint": "叙述与模式密度",
    "aggressiveness": "强度",
    "postHelp": {
      "off": "叙述层按原始 NDJSON 一一对应枚举。不生成模式。完全无损。",
      "light": "叙述中连续相同的公式折叠为区域。不输出模式层。",
      "standard": "在轻量级基础上，WL 模式识别会与单元格层并列输出模式层。",
      "aggressive": "在标准级基础上，适用时将按单元格的叙述记录替换为「参见模式 P-N」指针。"
    },
    "ctaInfo": "在工具箱中运行 · <0>异步</0> · 可放心离开页面。",
    "ctaInfoLine2": "输出通过短时效安全链接以单个 zip 形式下载。",
    "starting": "启动中…",
    "runExtractionButton": "运行提取",
    "unsupportedFormat": "不支持的格式：.{{ext}}。仅接受 .xlsx 和 .xlsm。",
    "whatProduces": "本工具的产出",
    "bundleAnatomy": "资产包结构",
    "fileTreeRoot": "bundle.zip ({jobid}.zip)",
    "fileLabel_one": "{{count}} 个文件",
    "fileLabel_other": "{{count}} 个文件",
    "recentRuns": "近期运行",
    "recentMetaSuffix": "· 仅本工具 · 每 4 秒刷新",
    "noRecentForTool": "暂无已完成的运行。",
    "tableHeaders": {
      "target": "目标",
      "finished": "完成时间",
      "duration": "耗时",
      "bundle": "资产包"
    },
    "tips": "提示",
    "tipsItems": {
      "deterministicTitle": "确定性输出",
      "deterministicBody": "相同的工作簿始终生成相同的资产包。",
      "formatsTitle": "仅支持 .xlsx / .xlsm",
      "formatsBody": "旧版 <0>.xls</0> / <1>.xlsb</1> 以及密码保护的工作簿会抛出类型化错误；请先去除密码。",
      "rawTitle": "原始层始终无损",
      "rawBody": "后处理只会改动叙述层和模式层；单元格级记录始终完整保留。",
      "pivotTitle": "深度级输出透视衍生计算",
      "pivotBody": "在 <0>pivots = deep</0> 下，每个透视输出单元格都会被表达为独立的等效 SUMIFS 表达式。",
      "scaleTitle": "可处理数十万单元格",
      "scaleBody": "较大的工作簿会生成较大的资产包，下载不受上传超时限制。"
    },
    "dropZone": {
      "drop": "将工作簿拖到此处",
      "or": "<0>.xlsx</0> 或 <1>.xlsm</1> · 点击选择",
      "replace": "替换",
      "ready": "已就绪可提取"
    },
    "depthLabels": {
      "off": "关闭",
      "light": "轻量",
      "standard": "标准",
      "deep": "深入",
      "forensic": "取证级",
      "aggressive": "激进"
    },
    "bundleCategories": {
      "index": "索引",
      "corpus": "语料(RAG markdown)",
      "archive": "归档(zstd NDJSON)",
      "narrative": "叙述 markdown",
      "audit": "审计"
    },
    "anatomy": {
      "workbookOverview": {
        "title": "工作簿概览",
        "description": "工作表清单、计算设置"
      },
      "inputs": {
        "title": "输入项",
        "description": "模型依赖的叶子单元格"
      },
      "cycles": {
        "title": "循环依赖",
        "description": "迭代计算依赖（若存在）"
      },
      "namedRanges": {
        "title": "命名区域",
        "description": "工作簿与工作表作用域的名称"
      },
      "tables": {
        "title": "表格",
        "description": "Excel 结构化表格"
      },
      "formulas": {
        "title": "公式",
        "description": "按工作表拓扑排序"
      },
      "pivots": {
        "title": "透视表",
        "descriptionConfigs": "配置",
        "descriptionDeep": "配置 + 展平的衍生计算"
      },
      "powerQuery": {
        "title": "Power Query",
        "description": "按查询的 M 源码"
      },
      "vba": {
        "title": "VBA",
        "descriptionVerbatim": "模块原文",
        "descriptionStandard": "模块 + 过程索引",
        "descriptionDeep": "模块 + 过程索引 + 交互"
      },
      "charts": {
        "title": "图表",
        "descriptionInventory": "清单",
        "descriptionSeries": "清单 + 系列数据源"
      },
      "conditionalFormatting": {
        "title": "条件格式",
        "descriptionRules": "规则",
        "descriptionDeep": "规则 + 按单元格归属"
      },
      "dataValidation": {
        "title": "数据验证",
        "description": "规则 + 按单元格归属"
      },
      "externalLinks": {
        "title": "外部链接",
        "description": "工作簿引用"
      },
      "patterns": {
        "title": "模式",
        "description": "WL 签名公式折叠"
      }
    }
  },
  "extractorRun": {
    "loading": "加载任务中…",
    "failedToLoad": "加载任务失败",
    "failedToCancel": "取消任务失败",
    "cancelling": "取消中…",
    "cancelRun": "取消运行",
    "backToToolbox": "← 返回工具箱",
    "runAnother": "再来一次 →",
    "presetLabel": "预设",
    "postLabel": "后处理",
    "sheetCount": "{{count}} 张工作表",
    "pipeline": "正在提取模型",
    "statusLabel": "已完成",
    "starting": "启动中",
    "failedStatus": "失败",
    "awaitingPlan": "等待执行计划…",
    "counters": "计数",
    "runMarkedStaleTitle": "运行被标记为停滞",
    "runMarkedStaleBody": "在预期时间内未收到本次运行的进度信号，因此已在无结果的情况下关闭。请重试。",
    "runCancelled": "此次运行已取消。",
    "runComplete": "运行完成。",
    "completeStats": {
      "totalTime": "总耗时",
      "bundle": "资产包",
      "formulas": "公式",
      "edges": "依赖边"
    },
    "bundleContents": "资产包内容",
    "exportToWorkspace": "导出至工作区",
    "downloadBundle": "下载资产包",
    "downloadBundleWithSize": "下载资产包 · {{size}} KB",
    "preparing": "准备中…",
    "runFailedTitle": "本次提取未完成",
    "runFailedNote": "本次运行在生成资产包前即中止，因此无法就该工作簿报告任何内容。请重新运行；若再次出现，请提供运行编号 {{jobId}}。",
    "noDetail": "未提供详情",
    "manifestNotAvailable": "资产包清单尚未就绪 —— 请稍后刷新。",
    "headline": "模型提取器 (Extractor)",
    "stats": {
      "sheet_count": "工作表数",
      "cell_count": "单元格数",
      "formula_cell_count": "公式数",
      "named_range_count": "命名区域",
      "table_count": "表格",
      "pivot_count": "透视表",
      "power_query_count": "Power Query",
      "vba_module_count": "VBA 模块",
      "vba_procedure_count": "VBA 过程",
      "conditional_formatting_rule_count": "条件格式规则",
      "data_validation_rule_count": "数据验证规则",
      "chart_count": "图表",
      "chart_series_count": "图表系列",
      "external_link_count": "外部链接",
      "graph_node_count": "图节点",
      "graph_edge_count": "图边",
      "cycle_count": "循环",
      "pivot_cell_count": "透视衍生计算",
      "named_range_member_count": "命名区域成员",
      "cf_membership_count": "条件格式归属",
      "dv_membership_count": "数据验证归属",
      "vba_interaction_count": "VBA 交互",
      "pattern_count": "模式",
      "warning_count": "警告"
    },
    "exportTitleLabel": "提取器"
  },
  "gatekeeperRun": {
    "exportTitleLabel": "提交守门员"
  },
  "common": {
    "loading": "加载中…",
    "loadFailed": "无法加载。",
    "tryAgain": "重试",
    "attachContextDocument": "附加上下文文档",
    "deleteRun": "删除此次运行",
    "deleteRunTitle": "确认删除此次运行？",
    "deleteRunBody": "此操作将永久删除运行记录及其产出的全部产物（源文件、输出、图表），且无法撤销。",
    "deleteRunConfirm": "删除",
    "deleteRunDeleting": "删除中…",
    "deleteRunFailed": "删除失败",
    "cancel": "取消",
    "close": "关闭",
    "refresh": "刷新",
    "running": "运行中",
    "runAnother": "再运行一次",
    "runFailed": "运行失败",
    "failedChip": "失败",
    "dismiss": "忽略",
    "noRunsYet": "暂无运行记录",
    "pastRunsHint": "历史运行完成后将显示在此处。",
    "stale": "已停滞",
    "cancelled": "已取消",
    "interrupted": "已中断",
    "runInterruptedTitle": "运行已中断",
    "runInterruptedBody": "运行所在的服务已关闭，本次运行提前结束，未产生任何结果。请发起新的运行以重试。",
    "discard": "丢弃",
    "downloading": "下载中…",
    "download": "下载",
    "viewFull": "查看完整内容",
    "preparingZip": "正在准备压缩包…",
    "loadingJob": "加载中…",
    "loadingJobHint": "正在获取检查任务状态。",
    "errorBackToToolbox": "返回工具箱",
    "parentModelArchived": "该模型已归档。新的运行和导出到项目已停用；该模型此前产出的全部内容仍会列出并可下载。",
    "parentModelMissing": "请从某个模型中打开工具箱，以开始新的运行。"
  },
  "logicInspector": {
    "title": "缺陷扫描",
    "subtitle": "对模型代码中的数据使用与逻辑反模式进行静态扫描 —— Python / R / SAS / SQL / JS / TS / Java / Go / Rust。",
    "intro": "导入模型代码 —— Python / R / SAS / SQL / JS / TS / Java / Go / Rust 等。此处不支持 Excel 工作簿；如果您的模型在 Excel 中，请先使用 <strong>模型提取器</strong> 工具。资产包仅保留在您的工具箱中，不会自动导入工作区。",
    "stepPickFiles": "1. 选择文件",
    "filePickerHint": "任何文本或代码文件 —— Python、R、SAS、SQL、JS、TS 等。Excel 文件请使用模型提取器。",
    "stepPickCategories": "2. 选择类别",
    "categoriesHint": "已禁用的类别即便资产包中含有相关问题，也不会产生任何发现。",
    "addCustomCheck": "添加自定义检查…",
    "customCheckPlaceholder": "例如「标记任何未设置 random.seed 的拟合模型」",
    "submitting": "提交中…",
    "submittingHint": "正在排队检查任务。",
    "runCta": "运行缺陷扫描",
    "recentRuns": "近期运行",
    "noCompletedRuns": "暂无已完成的运行。",
    "colTarget": "目标",
    "colFindings": "发现",
    "colCategories": "类别",
    "colFinished": "完成时间",
    "colDuration": "耗时",
    "colStatus": "状态",
    "huntingFlaws": "正在扫描缺陷",
    "huntingFlawsHint": "状态：{{status}}…",
    "runFailedTitle": "本次缺陷检查未完成",
    "runFailedNote": "本次运行在产生任何结论前即中止，因此无法就该代码报告任何内容 —— 包括其是否没有缺陷。请重新运行；若再次出现，请提供运行编号 {{jobId}}。",
    "inspectionComplete": "检查完成",
    "completed": "已完成",
    "findingsCount_one": "{{count}} 项发现",
    "findingsCount_other": "{{count}} 项发现",
    "categoriesEnabled": "已启用 {{count}} 个类别",
    "exportToWorkspace": "导出到工作区",
    "noFindingsDetected": "未发现问题。"
  },
  "docReviewer": {
    "title": "文档审查",
    "subtitle": "对第三方模型文档进行单文档一致性与合规性审查。",
    "intro": "上传一份模型文档产物(.docx · .pdf · .md · .txt · .rst)。文档类型为<strong>可选项</strong>：选择后将增加一次以对应知识库为范围的合规检查；不选择则仅运行写作质量检查。",
    "stepPickDocument": "1. 选择文档",
    "filePickerHint": "单个文档 —— .docx · .pdf · .md · .txt · .rst。",
    "stepPickTemplate": "2. 添加模板或要求说明（可选）",
    "templateHint": "上传本次提交应遵循的模板、必备内容清单或要求说明文档 —— Bennie 会据此推导出一份要求清单，并按该清单对文档评分。若不上传，则<strong>不会运行要求符合性检查</strong>；报告将标记为「未请求」。",
    "templateFilePickerHint": "单个文档 —— .docx · .pdf · .md · .txt · .rst。",
    "stepPickDocumentType": "3. 选择文档类型（可选）",
    "documentTypeHint": "垂直领域 → 文档类型决定合规检查所用的参考资料。若不选择，则<strong>不会运行合规检查</strong>；报告将标记为「未请求」。",
    "selectScopeCta": "选择文档类型",
    "editScope": "编辑",
    "clearScope": "清除",
    "cancelScope": "取消",
    "scopeSummary": "已选择：<strong>{{title}}</strong> · 文档类型：<strong>{{type}}</strong>",
    "submitting": "提交中…",
    "submittingHint": "正在创建检查任务。",
    "runCta": "运行文档审查",
    "recentRuns": "近期运行",
    "noCompletedRuns": "暂无已完成的运行。",
    "colDocument": "文档",
    "colMode": "模式",
    "colFindings": "发现",
    "colVerdict": "总体结论",
    "colFinished": "完成时间",
    "colStatus": "状态",
    "modeNoDocumentType": "未选择文档类型",
    "modeUnreadable": "无法读取",
    "modeUnreadableHint": "本次运行按当前格式记录了结果，但合规部分缺失或格式有误，因此无法确定是否使用了文档类型。这不是通过的结果。",
    "inspectingDocument": "正在检查文档",
    "runningChecks": "正在执行已请求的检查…",
    "reviewComplete": "审查完成",
    "completed": "已完成",
    "runIncomplete": "审查未完成",
    "runIncompleteChip": "未完成",
    "runIncompleteHeading": "部分检查未完成",
    "runIncompleteNote": "本次运行未得出总体结论，因此不能视为通过。下方显示的是已完成的检查，各自附有其结果。",
    "runCancelledTitle": "运行已取消",
    "runCancelledNote": "本次运行在完成前被取消，因此未对该文档生成审查结果。",
    "runStaleTitle": "运行被标记为过期",
    "runStaleNote": "在预期时间内未收到本次运行的进度信号，因此已在无结果的情况下关闭。请重新提交该文档。",
    "advisoryPassed": "可用于下游流程。",
    "advisoryPassedWithIssues": "在下游流程依赖本文档之前，请先提交完整验证。",
    "advisoryFailed": "需要大幅返工 —— 在下游使用本报告之前请重新运行。",
    "advisoryNotRequestedScope": "{{advisory}}此结论未涵盖未请求的检查：{{checks}}。",
    "advisoryScopeSeparator": "、",
    "validateAction": "验证",
    "downloadReport": "下载报告（.docx）",
    "downloadWorkbook": "下载工作簿（.xlsx）",
    "resubmitAction": "重新提交",
    "internalRegulatoryCount": "内部 {{internal}} · 合规 {{regulatory}}",
    "internalCountNoRegulatory": "内部 {{internal}} · 未请求合规检查",
    "internalInconsistencies": "内部一致性问题",
    "regulatoryNonCompliance": "合规性问题",
    "regulatoryNotRequestedNote": "未请求 —— 未选择文档类型，因此合规性检查未运行。这不是通过的结果。",
    "notRequestedChip": "未请求",
    "noDocumentTypeSelected": "未选择文档类型",
    "noInternalFindings": "未发现内部问题。",
    "noRegulatoryFindings": "未发现合规问题。",
    "runnerFailed": "运行器失败",
    "scope": "范围",
    "writingQualityCheck": "写作质量检查",
    "internalRequirementCheck": "内部要求检查",
    "scoreOutOf": "{{score}}%",
    "itemScore": "{{score}}/{{weight}}",
    "sectionNotRequested": "未请求",
    "sectionNotRequestedNote": "本次运行未启用该检查，因此未执行。这不是通过的结果。",
    "requirementNotRequestedNote": "未请求 —— 未上传模板文档，因此未生成要求清单，该检查未执行。这不是通过的结果。",
    "sectionFailed": "该检查未完成",
    "sectionFailedReason": {
      "checklist_not_derived": "无法从您上传的模板中提取出任何要求，因此没有可用于核对该文档的依据。请改用将各项要求写成明确条款的模板，然后重新运行该检查。",
      "checklist_too_large": "该模板产生的要求过多，单次运行无法逐条核对整份文档。请将模板缩减至此处真正需要的部分，或拆分到多次运行中。",
      "response_incomplete": "该检查在读完之前已无余量，其结果只能覆盖文档的一部分，因此未予显示。请改用更短的文档，或将本文档拆分后分别运行。",
      "retrieval_unavailable": "该检查无法访问其用于比对的参考资料，因此已中止。这与您的文档无关 —— 请稍后重试；若持续出现，请提供运行编号 {{jobId}}。",
      "timed_out": "该检查未在规定时间内返回结果，已被中止。请重新运行；使用更短的文档不易耗时过长。若再次出现，请提供运行编号 {{jobId}}。",
      "unknown": "该检查在产生结果前中止，因此无法就其报告任何内容 —— 包括该文档是否合格。请重新运行；若再次出现，请提供运行编号 {{jobId}}。"
    },
    "runFailedTitle": "本次审阅未完成",
    "runFailedNote": "本次运行在任何检查产生结果前即中止，因此无法就该文档报告任何内容 —— 包括其是否合格。请重新运行；若再次出现，请提供运行编号 {{jobId}}。",
    "sectionUnreadable": "无法读取该部分",
    "sectionUnreadableNote": "本次运行按当前格式记录了结果，但该部分缺失或格式有误，因此无法报告任何内容。这不是通过的结果。",
    "failedChip": "失败",
    "unreadableChip": "无法读取",
    "itemUnreadable": "无法读取该评分项",
    "itemUnreadableNote": "其分数、权重或发现项缺失或格式有误，因此无法报告任何内容。这不是通过的结果。",
    "noItemFindings": "该评分项没有发现问题。",
    "checklistTitle": "生成的要求清单",
    "checklistSource": "来源：{{filename}}",
    "checklistWeight": "权重{{weight}}",
    "checklistAnchor": "模板出处：{{sourceRef}}",
    "checklistDerivedBy": "由 {{model}} 推导 · prompt 集 {{promptSetVersion}} · 模板 SHA-256 {{templateSha256}}",
    "checklistNotRecorded": "未记录",
    "checklistSourceUnrecorded": "未记录本 checklist 所依据的模板。这不是通过的结果。",
    "checklistEntryUnreadable": "无法读取该 checklist 条目",
    "checklistEntryUnreadableNote": "其权重缺失或格式有误，因此无法作为推导出的评分标准的一部分呈现，上方各条权重也不构成完整的总和。这不是通过的结果。",
    "checklistMissing": "未记录生成的要求清单",
    "checklistMissingNote": "该检查已评分，但评分所依据的清单未随本次运行保存，因此无法将评分标准追溯到模板。",
    "legacySchemaNote": "本次运行早于当前结果格式，因此没有总体结论和分项得分。此处按记录原样显示。",
    "sectionStatesHint": "写作质量：{{writing}} · 内部要求：{{requirement}} · 合规：{{regulatory}}",
    "state_ok": "已执行",
    "state_not_requested": "未请求",
    "state_failed": "失败",
    "state_unreadable": "无法读取",
    "verdictPassed": "通过",
    "verdictPassedWithIssues": "通过但存在问题",
    "verdictFailed": "未通过",
    "verdictWithheld": "无结论",
    "verdictWithheldHint": "本次运行未记录总体结论，因此不能视为通过。请打开该运行查看各项检查的结果。",
    "verdictUnreadable": "无法读取",
    "verdictUnreadableHint": "本次运行记录的总体结论格式无法读取，因此无法就此作出报告。这不是通过的结果。",
    "verdictLegacyHint": "本次运行早于当前结果格式，从未为其计算过总体结论。",
    "resultUnreadable": "无法读取此结果",
    "resultUnreadableNote": "本次运行报告为成功，但其结果记录采用了 Bennie 无法识别的格式，因此无法就该文档报告任何内容 —— 包括它是否合格。请重新运行；若再次出现，请提供运行编号 {{jobId}}。",
    "verdictNoResultHint": "本次运行未记录任何结果，因此没有可报告的总体结论。",
    "verdictShapeUnreadableHint": "本次运行的结果记录格式无法读取，因此无法就此作出报告。这不是通过的结果。"
  },
  "findingsTable": {
    "searchPlaceholder": "搜索描述、位置、证据…",
    "findingsCount_one": "{{count}} 项发现",
    "findingsCount_other": "{{count}} 项发现",
    "filteredOfTotal": "{{shown}} / {{total}}",
    "noFindingsMatchFilter": "当前筛选条件下无匹配的发现。",
    "noFindingsDetected": "未发现问题。",
    "colSeverity": "严重程度",
    "colCategory": "类别",
    "colLocation": "位置",
    "colDescription": "描述",
    "ariaExpand": "展开",
    "ariaCollapse": "收起",
    "evidenceExcerpt": "证据摘录",
    "citedAuthority": "引用依据 —— {{framework}} {{reference}}",
    "ckRecord": "CK 记录：{{id}}",
    "filterLabel": "筛选 {{label}}",
    "noValues": "无可选值。",
    "clear": "清除",
    "severityVocabularyUnavailable": "严重程度标签未能加载，因此严重程度以其存储值显示。"
  },
  "recentJobs": {
    "noRunsYet": "暂无运行记录",
    "pastRunsHint": "历史运行完成后将显示在此处。"
  },
  "exportModal": {
    "title": "将 {{tool}} 数据导出到工作区",
    "intro": "仅显示当前仍在接收数据上传的工作区。",
    "searchPlaceholder": "按名称或 id 搜索工作区",
    "noWorkspacesMatch": "未匹配到工作区。",
    "unnamed": "（未命名）",
    "eligibilityOpen": "开放",
    "eligibilityClosed": "已关闭",
    "cancel": "取消",
    "refresh": "刷新",
    "export": "导出",
    "createProject": "新建项目",
    "chooseModel": "选择一个模型",
    "createCheckFailed": "暂时无法核对 — 请重试",
    "targetsFailed": "无法加载您的工作区，因此暂时没有可导出的目标。请稍后重试。",
    "importFailed": "导出未完成，因此没有任何内容发送到该工作区。请稍后重试。",
    "ineligibility": {
      "archived": "该工作区已归档，无法接收新数据。",
      "model_archived": "该工作区所属的模型已归档，无法接收新数据。",
      "no_workflow_state": "该工作区尚未完成设置。",
      "no_approved_plan": "请先批准该工作区的计划，然后再导出到此处。",
      "report_generation_started": "报告生成已开始，该工作区不再接收新数据。",
      "failed_state": "请先处理该工作区失败的步骤，然后再导出到此处。",
      "workspace_busy": "该工作区正忙——请等待当前步骤完成后重试。",
      "workspace_terminal": "该工作区已标记为完成，因此无法接收新数据。",
      "unknown_workflow_state": "无法确定该工作区当前所处的阶段，因此它无法接收新数据。",
      "auditing_import_requires_phase": "此工作区按分析阶段接收文件——请在其「设计有效性」或「运行有效性」标签页中添加。",
      "default": "该工作区当前无法接收新数据。"
    }
  },
  "uploadedFilesTree": {
    "header": "已上传文件"
  },
  "gatekeeper": {
    "title": "提交守门员 (Gatekeeper)",
    "subtitle": "提交包接收检查",
    "package": {
      "title": "1. 选择提交包",
      "help": "支持混合格式接收 —— .docx · .xlsx · .pdf · 代码文件 · .txt。最多 200 个文件，单次提交总计 25 MB。无法读取的文件将被标记为需人工复核。",
      "dropHeadline": "添加提交文件",
      "filesButton": "文件",
      "folderButton": "文件夹",
      "dropHint": "或拖拽到此处",
      "queueMeta": "{{count}} 个文件 · {{size}}",
      "clearAll": "全部清除",
      "tooManyFiles": "文件过多（上限 {{max}}）。请移除部分文件后继续。",
      "totalTooLarge": "总大小超过 {{max}}。请移除部分文件后继续。",
      "fileTooLarge": "{{name}} 超过 {{max}}。请移除后继续。"
    },
    "template": {
      "title": "2. 选择提交模板",
      "help": "自由格式的清单，说明提交包应包含哪些内容。可粘贴文本，也可上传 Bennie 支持读取的任意格式文件。",
      "paste": "粘贴文本",
      "upload": "上传文件",
      "pastePlaceholder": "列出提交包应包含的产物与内容 —— 模型文件、验证报告、测试结果、方法论说明等。",
      "dropLabel": "点击选择 .docx · .pdf · .md · .txt 文件。"
    },
    "knobs": {
      "title": "3. 配置运行",
      "sampling": "采样深度",
      "samplingHelp": "每个文件被阅读的深度",
      "sampling_sparse": "稀疏",
      "sampling_balanced": "均衡",
      "sampling_dense": "密集",
      "strictness": "判定严格度",
      "strictnessHelp": "判定环节的严苛程度",
      "strictness_loose": "宽松",
      "strictness_balanced": "均衡",
      "strictness_strict": "严格",
      "outputLanguage": "输出语言",
      "outputLanguageHelp": "判定说明的语言",
      "lang_en": "English",
      "lang_fr": "Français"
    },
    "runCta": "运行接收检查",
    "submitting": "提交中…",
    "submittingHint": "正在排队接收检查任务。",
    "statusLabel": {
      "completed": "已完成"
    },
    "recent": {
      "title": "近期运行",
      "metaSuffix": "· 仅本工具 · 每 4 秒刷新",
      "empty": "暂无已完成的运行。",
      "headerHeadline": "运行",
      "headerFinished": "完成时间",
      "headerVerdict": "判定结果",
      "headerFiles": "文件数",
      "headerDuration": "耗时",
      "headerStatus": "状态"
    },
    "fileLabel_one": "{{count}} 个文件",
    "fileLabel_other": "{{count}} 个文件",
    "verdict": {
      "pass": "通过",
      "fail": "未通过",
      "error": "错误",
      "cancelled": "已取消",
      "stale": "已停滞",
      "passHeadline": "提交包内容足以开展工作。",
      "failHeadline": "关键产物缺失 —— 提交包尚未就绪。"
    },
    "risk": {
      "high": "高风险",
      "medium": "中风险",
      "low": "低风险"
    },
    "run": {
      "title": "接收检查运行",
      "inProgress": "进行中",
      "filesProcessed": "已处理文件",
      "starting": "启动中…",
      "preparing": "正在准备提交包…",
      "skimProgress": "已速读 {{skimmed}} / {{total}} 个文件",
      "processedSummary": "{{total}} 个文件 · 已读 {{ok}} 个 · 标记 {{attention}} 个",
      "phaseExtracting": "读取文件内容",
      "phaseSkimming": "速读文件",
      "phaseJudging": "生成判定结果",
      "verdictPending": {
        "title": "正在生成判定结果…",
        "subtitle": "将速读清单与您的提交模板进行比对。"
      },
      "phaseSkimComplete": "速读完成",
      "phaseComplete": "已完成",
      "statusOk": "正常",
      "statusAttention": "需关注",
      "statusProcessing": "处理中",
      "statusPending": "待处理",
      "missingTitle": "提交包中缺失的内容",
      "missingEmpty": "无缺失 —— 提交包完整覆盖模板要求。",
      "attentionTitle": "需人工复核的文件",
      "errorTitle": "运行未能完成",
      "runFailedTitle": "本次入口检查未完成",
      "runFailedNote": "本次运行在生成判定结果前即中止，因此无法就该提交包报告任何内容 —— 包括其是否完整。请重新运行；若再次出现，请提供运行编号 {{jobId}}。",
      "cancelledNote": "此次运行已取消。",
      "runAnother": "再运行一个提交包",
      "backToDashboard": "返回工具箱",
      "pollFailed": "无法刷新运行状态。",
      "statsFiles": "文件",
      "statsOk": "已速读",
      "statsAttention": "需关注",
      "completeTitle": "检查完成",
      "exportToWorkspace": "导出至工作区"
    }
  },
  "filePicker": {
    "dropFileHere": "拖入一个文件",
    "dropFilesHere": "拖入多个文件",
    "fileButton": "文件",
    "filesButton": "文件"
  },
  "submitError": {
    "tooLarge": "本次提交超过 {{max}} 的上传限制，无法发送。请移除或拆分较大的文件后重试。",
    "fileTooLarge": "{{name}} 超过 {{max}} 的上传限制。",
    "totalTooLarge": "总大小超过 {{max}} 的上传限制。请移除部分文件后继续。",
    "generic": "无法启动本次运行。请重试——若持续失败，请联系支持人员。"
  },
  "download": {
    "session": "您的登录状态已过期。请重新登录后再下载。",
    "notReady": "本次运行尚未完成。请等待完成后再下载。",
    "missing": "本次运行没有可下载的文件。",
    "timeout": "下载耗时过长已中止。请重试。",
    "failed": "下载未能完成。请重试。"
  },
  "codeWalkthrough": {
    "exportToWorkspace": "导出到工作区",
    "title": "代码逐行审阅",
    "subtitle": "按行锚定的审阅工作簿",
    "intro": "生成一个 Excel 工作簿：每一行代码占一行，且每一行都带有明确的处置说明。添加基线版本可审阅变更；添加验证报告可将其结论落到相关代码行上。",
    "stepCurrent": "模型代码",
    "currentHint": "拖入脚本或整个文件夹。仓库辅助目录（.git、.venv）会被排除。",
    "stepBaseline": "与基线版本比较",
    "baselineHint": "同一批脚本的早期版本。同名文件会自动进行比对。",
    "stepReport": "使用验证报告进行标注",
    "reportHint": "一份验证报告（.md、.docx、.pdf）。其要点会被落到相关代码行上。",
    "willProduce": "将生成：",
    "mode": {
      "fullFile": "完整逻辑解读",
      "diff": "变更解读（diff）",
      "fullFileWithReport": "带标注的代码（结合报告）",
      "diffWithReport": "变更解读（结合报告）"
    },
    "submitting": "正在启动审阅",
    "submittingHint": "正在上传文件并将任务加入队列。",
    "runCta": "生成工作簿",
    "recentRuns": "最近的运行",
    "noCompletedRuns": "尚无已完成的运行。",
    "colTarget": "文件",
    "colRows": "行数",
    "colFinished": "完成时间",
    "colDuration": "耗时",
    "colStatus": "状态",
    "running": "正在生成工作簿",
    "runningHint": "正在逐个文件进行标注（{{status}}）。",
    "runFailedTitle": "本次代码逐行审阅未完成",
    "runFailedNote": "本次运行在生成工作簿前即中止，因此无法就这些文件报告任何内容。请重新运行；若再次出现，请提供运行编号 {{jobId}}。",
    "workbookReady": "工作簿已就绪",
    "complete": "已完成",
    "completeWithGaps": "已完成——需人工复核",
    "gapsExplainer": "工作簿已完整生成。发布前，请审阅人先关注上方的琥珀色标记。",
    "chipFiles": "{{n}} 个文件",
    "chipRows": "{{n}} 行",
    "chipTruncated": "{{n}} 个单元格被截断",
    "downloadWorkbook": "下载工作簿",
    "preparingDownload": "正在准备…",
    "chipChangedRows_one": "{{count}} 行变更",
    "chipChangedRows_other": "{{count}} 行变更",
    "chipUnannotated_one": "{{count}} 行变更未逐行处置",
    "chipUnannotated_other": "{{count}} 行变更未逐行处置",
    "chipUnannotatedInterpretation_one": "{{count}} 行未逐行处置",
    "chipUnannotatedInterpretation_other": "{{count}} 行未逐行处置",
    "noBaselineSupplied": "未提供基线版本，因此没有进行任何比对——每一行都是单独解读的。",
    "chipUnplaced_one": "{{count}} 条报告结论未落到代码上",
    "chipUnplaced_other": "{{count}} 条报告结论未落到代码上",
    "chipDropped_one": "{{count}} 条批注无法定位",
    "chipDropped_other": "{{count}} 条批注无法定位",
    "chipCommentColumns_other": "{{count}} 个批注列",
    "inputsHeading": "本次运行",
    "inputsComparedWith": "与 {{file}} 比对",
    "inputsInterpreted": "单独解读",
    "inputsReport": "验证报告",
    "inputsUnmatchedBaselines": "没有任何文件映射到的基线文件（已忽略）",
    "mappingHeading": "比对基线",
    "mappingHint": "名称明显对应时已自动预填，可随意更改。留空表示单独审阅该文件；没有任何文件映射到的基线会被忽略。",
    "mappingNone": "— 不比对，单独审阅 —",
    "mappingWillCompare": "变更审阅",
    "mappingWillInterpret": "单独解读",
    "mappingAriaFor": "{{file}} 的基线"
  }
}
